import { clsx } from 'clsx';

export const ProgressBarKYC = ({
  length,
  currentStep,
  className,
}: {
  length: number;
  currentStep: number;
  className?: string;
}) => (
  <div className={clsx('w-full md:w-2/3 grid grid-cols-4', className)}>
    {new Array(length).fill(null).map((_, i) => (
      <div
        className={clsx(
          'flex items-center justify-end relative group duration-300',
          currentStep < i && 'opacity-20'
        )}
        key={i}
      >
        <div className='w-full absolute right-0 h-2 bg-blue-500' />
        <div className='relative w-6 h-6 bg-blue-500 text-white rounded-full flex justify-center items-center'>
          {i + 1}
        </div>
      </div>
    ))}
  </div>
);
